import { z } from "zod";
import { BladeCommonSchema } from "../common";
import { RichTextSchema } from "../../fragments/RichText";
import { ImageMediaSchema } from "../../fragments/Media";
import { IconLinkSchema } from "../../fragments/IconLink";
import { LinkItemSchema } from "../../fragments/LinkItem";
const AuthorSchema = z.object({
    name: z.string(),
});
export const ArticleMastheadBladeSchema = BladeCommonSchema.extend({
    banner: ImageMediaSchema,
    title: z.string(),
    description: RichTextSchema.optional(),
    publishDate: z.string(),
    category: LinkItemSchema.optional(),
    socialLinks: z.array(IconLinkSchema).optional(),
    tags: z.array(LinkItemSchema).optional(),
    authors: z.array(AuthorSchema).optional(),
});
export const ArticleMastheadBladeTypeValues = ["articleMasthead"];
export const ArticleMastheadBladeTypesSchema = z.enum(ArticleMastheadBladeTypeValues);
export const ArticleMastheadBladeTypes = ArticleMastheadBladeTypesSchema.enum;
export const ArticleMastheadBladesContractSchema = ArticleMastheadBladeSchema.extend({
    type: ArticleMastheadBladeTypesSchema,
});
export const ArticleMastheadContractSchema = ArticleMastheadBladeSchema.extend({
    type: z.literal(ArticleMastheadBladeTypes.articleMasthead),
});
//# sourceMappingURL=index.js.map